import React, { } from "react";
import { Box, Button, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";
import API from "../../libs/API";
import { getText } from "../../libs/utils";

const TextBox = styled('textarea')(({ theme }) => ({
  maxWidth: '480px',
  width: '100%',
  resize: 'none',
  padding: '20px',
  borderRadius: '6px',
  background: "#F3F6F6",
  fontFamily: 'inherit',
  border: '1px solid #F3F6F6',
  fontSize: '14px',
}));

export const LinkText = styled(Link)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  color: `${theme.palette.primary.gray}`,
  textTransform: 'uppercase'
}));

export default function OrderFeedback({ orderCode, updateCallback, clientComment, ...props }) {

  const sendFeedback = (event) => {
    event.preventDefault();
    var formData = new FormData(event.target);
    const values = Object.fromEntries(formData);

    if (!values["comment"]) {
      return;
    }

    API.sendFeedback(orderCode, values["comment"], true).then(data => {
      if (data.success) {
        updateCallback();
      } else {
        window.showMessage(data.data[0].message);
      }
    });

  }

  return (
    <Box sx={{
      marginTop: '36px',
      maxWidth: '500px',
    }}>
      <Typography variant="regularCaption" mb={2} color="primary" display={"block"}>{getText("orderFeedbackText")}</Typography>
      <form onSubmit={sendFeedback}>
        <TextBox name="comment" disabled={!!clientComment} value={clientComment || undefined} maxlength="1000" multiline rows="4" placeholder={getText("orderFeedbackPlaceholder")} variant="contained" />
        <Box sx={{ display: 'flex', marginTop: '16px', gap: '16px', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' } }}>
          {!clientComment && <Button
          
            sx={{
              padding: '15px 31px',
              width: {
                xs: '100%', sm: 'auto',
              },
              minWidth: '240px'
            }}
            variant="contained" color="primary" type="submit" >{getText("orderFeedbackSend")}</Button>}
          <LinkText to={"/"} >{getText("stteBlockMainBtn")}</LinkText>
        </Box>
      </form>
    </Box>

  )
}